/* analytics-events.js — centralized custom-event dispatch for KPI tracking.
 *
 * One source of truth for all custom storefront events. Pushes to GA4
 * (window.gtag) and dataLayer (for any GTM consumers) in one call.
 *
 * Two integration patterns:
 *   1. Auto-listen for clicks on [data-track] elements. The data-track
 *      attribute value is the event name. Any data-track-* attributes on
 *      the same element are forwarded as event properties (with the
 *      "track-" prefix stripped, kebab-case left intact).
 *      Example:
 *        <button data-track="cup_select" data-track-axis="cup"
 *                data-track-value="Light Volume">Light Volume</button>
 *      Fires: trackEvent('cup_select', { axis: 'cup', value: 'Light Volume' })
 *
 *   2. Direct call from JS:
 *        window.trackEvent('quiz_complete', { cup: 'Light', size: 'M' });
 *
 * GA4 ecommerce events that require structured payloads (add_to_cart,
 * begin_checkout, purchase) should be fired directly via window.gtag with
 * the full items[] array — see fireAddToBag in main-product-laura-tempesta.
 * The data-track markers in this module track INTENT/CLICK signals only,
 * named with "_intent" or "_click" suffixes to avoid collision.
 *
 * TODO(KPI): finalize event names + property shapes with Alex once the
 * KPI list is approved. Current names are placeholders aligned with GA4
 * snake_case convention; rename in one place (here) when locked.
 */
(function () {
  'use strict';

  function trackEvent(name, props) {
    if (!name) return;
    var payload = props || {};
    if (typeof window.gtag === 'function') {
      window.gtag('event', name, payload);
    }
    // Mirror to dataLayer for GTM / non-gtag consumers.
    window.dataLayer = window.dataLayer || [];
    var dl = { event: name };
    for (var k in payload) {
      if (Object.prototype.hasOwnProperty.call(payload, k)) dl[k] = payload[k];
    }
    window.dataLayer.push(dl);
  }
  window.trackEvent = trackEvent;

  function readTrackProps(el) {
    var props = {};
    var attrs = el.attributes;
    for (var i = 0; i < attrs.length; i++) {
      var a = attrs[i];
      // data-track-foo-bar  ->  foo_bar
      var m = a.name.match(/^data-track-(.+)$/);
      if (m) props[m[1].replace(/-/g, '_')] = a.value;
    }
    return props;
  }

  function onReady(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  onReady(function () {
    // Click-based events (delegated, so dynamically inserted elements work).
    document.addEventListener('click', function (e) {
      var target = e.target;
      if (!target || !target.closest) return;
      var el = target.closest('[data-track]');
      if (!el) return;
      var name = el.getAttribute('data-track');
      if (!name) return;
      trackEvent(name, readTrackProps(el));
    }, true);

    // Quiz completion — custom DOM event dispatched by the FYF quiz iframe.
    // The PDP also handles this event for auto-add behavior; this listener
    // is purely for analytics and doesn't interfere.
    document.addEventListener('derby:quiz:complete', function (e) {
      var rec = (e && e.detail) || {};
      // TODO(KPI): confirm payload shape with Alex.
      trackEvent('quiz_complete', {
        cup_size: rec.cupSize || '',
        shirt_size: rec.shirtSize || ''
      });
    });

    // Per-question quiz answer tracking. Tom's quiz (assets/derby-quiz.js)
    // renders each question into #questionsWrapper and wraps it in a
    // #div-{questionId} container with radio inputs inside. Listening
    // for radio change events inside #sizingQuizContainer lets us
    // capture every answer without modifying Tom's JS — works on the
    // Laura PDP modal AND the standalone promo Page 3, since both
    // mount the quiz under the same DOM IDs.
    //
    // Used to compute drop-off by question (start vs Q1 vs Q2 vs Q3
    // vs complete) and identify which questions cause bailouts.
    document.addEventListener('change', function (e) {
      var input = e.target;
      if (!input || input.type !== 'radio') return;
      var quizContainer = input.closest && input.closest('#sizingQuizContainer');
      if (!quizContainer) return;
      var questionDiv = input.closest('[id^="div-"]');
      var questionId = questionDiv ? questionDiv.id.replace('div-', '') : '';
      trackEvent('quiz_question_answered', {
        question_id: questionId,
        answer: input.value
      });
    }, true);
  });
})();
